import { render, staticRenderFns } from "./KlarnaEntry.vue?vue&type=template&id=06760d08"
import script from "./KlarnaEntry.vue?vue&type=script&lang=js"
export * from "./KlarnaEntry.vue?vue&type=script&lang=js"
import style0 from "./KlarnaEntry.vue?vue&type=style&index=0&id=06760d08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports